 
 const LoadingSpinner = ({className}) => (
    <div className={className} role="status">
    </div>
  );

  export default LoadingSpinner;